import { render, staticRenderFns } from "./UiImages.vue?vue&type=template&id=69bec0f2&"
import script from "./UiImages.vue?vue&type=script&lang=js&"
export * from "./UiImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports